<nav-menu *ngIf="loginDisplay && !isPopoutRoute"></nav-menu>
<div class="container-fluid" *ngIf="!isPopoutRoute">
    <router-outlet *ngIf="!isIframe"></router-outlet>
</div>
<router-outlet *ngIf="isPopoutRoute && !isIframe"></router-outlet>

<user-settings *ngIf="loginDisplay && !isPopoutRoute"></user-settings>
<app-scout-ai-drawer *ngIf="loginDisplay && !isPopoutRoute"></app-scout-ai-drawer>

<div class="container" *ngIf="!loginDisplay && !isPopoutRoute">
    <div class="text-center p-5">
        <a href="#" (click)="login()">Log In</a>
    </div>
</div>
<ngx-ui-loader *ngIf="!isPopoutRoute"></ngx-ui-loader>
